import React from 'react';
import { Link } from 'react-router-dom';
import { FaStar } from 'react-icons/fa';
import { Helmet } from "react-helmet";

function Success() {
  return (
    <>
      <Helmet>
        <title>Haridem - Photography Studio Premium | Servizi Fotografici Professionali</title>
        <meta name="description" content="Haridem Photography Studio - Servizi fotografici professionali premium, ritratti artistici, gallerie contemporanee e attrezzatura fotografica di alta qualita" />
      </Helmet>

      <div className="success-container">
      <div className="success-icon"><FaStar /></div>
      <h1>Ordine Completato con Successo!</h1>
      <p>
        Grazie per aver scelto Haridem Photography Studio per i tuoi servizi fotografici premium.
      </p>
      <p>
        Riceverai una email di conferma con tutti i dettagli del tuo ordine entro pochi minuti.
      </p>
      <p>
        Il nostro team ti contattara a breve per pianificare la tua sessione fotografica 
        e discutere tutti i dettagli del servizio che hai acquistato.
      </p>
      <p>
        Non vediamo l ora di creare insieme a te immagini straordinarie e indimenticabili!
      </p>
      <Link to="/" className="back-home-btn">Torna alla Home</Link>
    </div>
  
    </>);
}

export default Success;